module.exports = __webpack_public_path__ + "img/resistance_resonator_transmission_type.5b1fd76a.svg";